import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';

export interface HasUnsavedChanges {
  isDirty: boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  if (!component.isDirty) return true;

  const modal = inject(NzModalService);

  return new Observable<boolean>(observer => {
    modal.confirm({
      nzTitle: 'Hold on — you have unsaved changes',
      nzContent:
        "Your edits are still lounging on this page, blissfully unaware they're about to be abandoned forever." +
        '<br><br>Hit <strong>↩ Go back and save</strong> to rescue them, or <strong>Leave without saving</strong> if you enjoy living dangerously.',
      nzOkText: 'Leave without saving',
      nzOkDanger: true,
      nzCancelText: '↩ Go back and save',
      nzOnOk:     () => { observer.next(true);  observer.complete(); },
      nzOnCancel: () => { observer.next(false); observer.complete(); },
    });
  });
};
